import { Mediator, app } from "modular-openscriptjs";
import { api, gc, uc } from "../declarations";
import { routes } from "../backendRoutes";

export class Award extends Mediator {
	$$user = {
		authenticated_loggedOut: (ed, event) => {
			this.getAwards(ed, event);
		},

		needs: {
			awards: (ed, event) => this.getAwards(ed, event),
		},
	};

	async getAwards(ed, event) {
		if (!gc.auth.value) return this.setAwards();

		api.get(routes.awards, { page: 1, interval: 20 }, { silent: true })
			.then((res) => this.setAwards(res.data.awards.data))
			.catch(() => this.setAwards());
	}

	setAwards(awards = []) {
		uc.awards.value = awards;
	}
}
